/* USE PROTECTION design: behaviour of the content pages - sections/up-about ("Despre noi"), up-tests ("Testat în
   lume"), up-win ("Câștigă"). Loaded async by each of those sections, after their markup, so it initialises the roots
   already in the DOM as soon as it runs (again at DOMContentLoaded, each root once); runs once per page (window.upPages).
   - About [data-u-about]: reveal on scroll (.u-rise / .u-rvl, staggered per parent through --u-d), count-up numbers
     ([data-count], data-fmt th = 1.000, m = 3,5M), parallax photo ([data-u-par] img --u-ps), timeline rail fill
     ([data-u-time] .u-ab-prog --u-tp). Armed only when motion is allowed: the section's inline script sets html.u-mo
     before paint and drops it again if this file never arrives, so reduced motion and no-JS show everything static.
     If the 4 s fallback already dropped html.u-mo (this file arrived late), the page stays static: nothing that is
     already being read fades out again.
   - Tests [data-u-tests]: the city tabs ([data-u-city] -> panel id) switch the panel inside the page and pause the
     videos of the panels they hide. ARIA tabs: roving tabindex, Left / Right / Home / End move and select.
     Videos play only on screen through assets/up.js ([data-u-inview]).
   - Win [data-u-win]: countdown [data-u-cd] to data-end (ISO date; without an offset = the store's wall-clock time,
     window.__mfStore.tz - RO Bucharest),
     the sticky mini countdown [data-u-sticky] shown (and taken out of inert) once the hero (.u-gx) is off screen.
     At the end, or with a date that cannot be read, the countdown and the sticky bar go away and the hero button
     takes its data-u-after label. [data-u-open][data-u-sec] (the Mystery card -> #bfinfo) shows only that part of
     the sheet ([data-u-bfsec]), as the mockup's data-sec; a tap on the header bar closes that sheet like the scrim.
   Ported from the mockup's script (site/src.html); ES5 like the rest of the theme JS. No tracking here. */
(function () {
  if (window.upPages) return;
  window.upPages = true;
  var D = document, H = D.documentElement;
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var motion = !reduce && 'IntersectionObserver' in window;
  function each(list, fn) { Array.prototype.forEach.call(list, fn); }
  function pad(n) { return (n < 10 ? '0' : '') + n; }

  /* ---------- About: reveal, count-up, parallax, timeline rail ---------- */
  var io = null, pars = [], rails = [], raf = 0;
  function fmt(el, v) {
    var f = el.getAttribute('data-fmt');
    el.textContent = f === 'th' ? String(v).replace(/\B(?=(\d{3})+(?!\d))/g, '.') : f === 'm' ? (v / 10).toFixed(1).replace('.', ',') + 'M' : String(v);
  }
  function count(el) {
    var to = +el.getAttribute('data-count'), f = el.getAttribute('data-fmt');
    var from = f === 'th' || f === 'm' ? 0 : Math.max(0, to - (to > 100 ? 40 : to)), t0 = performance.now();
    (function step(t) {
      var k = Math.min(1, (t - t0) / 1100), e = 1 - Math.pow(1 - k, 3);
      fmt(el, Math.round(from + (to - from) * e));
      if (k < 1) requestAnimationFrame(step);
    })(t0);
  }
  function onScroll() {
    if (raf) return;
    raf = requestAnimationFrame(function () {
      raf = 0; var vh = window.innerHeight;
      each(pars, function (par) {
        if (!par.offsetParent) return;
        var r = par.getBoundingClientRect(), k = Math.min(1, Math.max(0, (vh - r.top) / (vh + r.height))), img = par.querySelector('img');
        if (img) img.style.setProperty('--u-ps', (1.16 - 0.16 * k).toFixed(3));
      });
      each(rails, function (tl) {
        if (!tl.offsetParent) return;
        var r = tl.getBoundingClientRect(), k = Math.min(1, Math.max(0, (vh * 0.7 - r.top) / r.height)).toFixed(3), prog = tl.querySelector('.u-ab-prog i');
        if (!prog) return;
        prog.parentElement.style.setProperty('--u-tp', k); prog.style.setProperty('--u-tp', k);
      });
    });
  }
  function about(root) {
    if (root.__upInit) return; root.__upInit = 1;
    /* u-mo is set before paint by the section's inline script; gone = no motion, or the fallback gave up on us */
    if (!motion || !H.classList.contains('u-mo')) { H.classList.remove('u-mo'); return; }
    var groups = [];
    each(root.querySelectorAll('.u-rise,.u-rvl'), function (el) {
      var p = el.parentElement, g = null;
      for (var i = 0; i < groups.length; i++) if (groups[i].p === p) { g = groups[i]; break; }
      if (!g) { g = { p: p, n: 0 }; groups.push(g); }
      el.style.setProperty('--u-d', (g.n * 0.08) + 's'); g.n++;
    });
    io = io || new IntersectionObserver(function (es) {
      es.forEach(function (en) {
        if (!en.isIntersecting) return;
        var el = en.target; el.classList.add('u-in');
        each(el.querySelectorAll('[data-count]'), count);
        io.unobserve(el);
      });
    }, { threshold: 0.18, rootMargin: '0px 0px -8% 0px' });
    each(root.querySelectorAll('.u-rise,.u-rvl'), function (el) { if (!el.classList.contains('u-in')) io.observe(el); });
    each(root.querySelectorAll('[data-u-par]'), function (el) { pars.push(el); });
    each(root.querySelectorAll('[data-u-time]'), function (el) { rails.push(el); });
    onScroll();
  }
  if (motion) { window.addEventListener('scroll', onScroll, { passive: true }); window.addEventListener('resize', onScroll); }

  /* ---------- Tests: city tabs scroll nothing and never leave the page ---------- */
  function pick(b) {
    var root = b.closest('[data-u-tests]'), id = b.getAttribute('data-u-city');
    each(root.querySelectorAll('[data-u-city]'), function (x) {
      x.setAttribute('aria-selected', String(x === b)); x.setAttribute('tabindex', x === b ? '0' : '-1');
    });
    each(root.querySelectorAll('.u-wt-city'), function (p) {
      p.hidden = p.id !== id;
      if (p.hidden) each(p.querySelectorAll('video'), function (v) { v.pause(); });
    });
  }
  D.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-u-tests] [data-u-city]'); if (b) pick(b);
  });
  D.addEventListener('keydown', function (e) {
    var b = e.target.closest && e.target.closest('[data-u-tests] [data-u-city]'); if (!b) return;
    var tabs = b.closest('[data-u-tests]').querySelectorAll('[data-u-city]'), i = Array.prototype.indexOf.call(tabs, b), n = tabs.length, j = -1;
    if (e.key === 'ArrowRight') j = (i + 1) % n; else if (e.key === 'ArrowLeft') j = (i - 1 + n) % n;
    else if (e.key === 'Home') j = 0; else if (e.key === 'End') j = n - 1;
    if (j < 0) return;
    e.preventDefault(); tabs[j].focus(); pick(tabs[j]);
  });

  /* ---------- Win: countdown to the end of the campaign + sticky mini bar ---------- */
  /* the store's UTC offset (hours) at a moment. The zone is the store's own (multistore contract: window.__mfStore.tz,
     an IANA name from snippets/mf-store - RO Europe/Bucharest); +2 (Bucharest winter) when Intl cannot tell, 0 when the
     store sends no zone at all */
  var TZ = String((window.__mfStore && window.__mfStore.tz) || '');
  function roOffset(ms) {
    if (!TZ) return 0;
    try {
      var z = new Intl.DateTimeFormat('en-US', { timeZone: TZ, timeZoneName: 'shortOffset' }).formatToParts(new Date(ms));
      for (var i = 0; i < z.length; i++) if (z[i].type === 'timeZoneName') {
        if (z[i].value === 'GMT') return 0;
        var m = /GMT([+-]\d+)(?::(\d{2}))?/.exec(z[i].value); if (m) return +m[1] + (m[2] ? (m[1].charAt(0) === '-' ? -1 : 1) * m[2] / 60 : 0);
      }
    } catch (e) {}
    return TZ === 'Europe/Bucharest' ? 2 : 0;
  }
  function parseEnd(s) {
    s = String(s || '').replace(/^\s+|\s+$/g, '').replace(' ', 'T');
    var m = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})(?::(\d{2}))?$/.exec(s);
    if (!m) return Date.parse(s);
    var utc = Date.UTC(+m[1], +m[2] - 1, +m[3], +m[4], +m[5], +(m[6] || 0));
    return utc - roOffset(utc - 7200000) * 3600000;
  }
  function win(root) {
    if (root.__upInit) return; root.__upInit = 1;
    var el = root.querySelector('[data-u-cd]'); if (!el) return;
    var mini = root.querySelector('[data-u-mini]'), st = root.querySelector('[data-u-sticky]'), hero = root.querySelector('.u-gx');
    var cta = root.querySelector('[data-u-after]'), cells = el.querySelectorAll('[data-u]'), ob = null, timer = 0, over = false;
    var end = parseEnd(el.getAttribute('data-end'));
    function stickyOn(on) {
      if (!st) return;
      st.classList.toggle('u-on', on);
      if (on) st.removeAttribute('inert'); else st.setAttribute('inert', '');
    }
    function finish() {
      over = true; if (timer) clearInterval(timer); if (ob) ob.disconnect();
      el.style.display = 'none'; stickyOn(false); if (st) st.style.display = 'none';
      if (cta && cta.firstChild && cta.firstChild.nodeType === 3) cta.firstChild.nodeValue = cta.getAttribute('data-u-after') + ' ';
    }
    if (isNaN(end)) { if (window.console) console.warn('up-pages: countdown end date not understood:', el.getAttribute('data-end')); finish(); return; }
    function tick() {
      var t = Math.floor((end - Date.now()) / 1000); if (t <= 0) { finish(); return; }
      var d = Math.floor(t / 86400); t %= 86400;
      var v = { d: d, h: Math.floor(t / 3600), m: Math.floor(t % 3600 / 60), s: t % 60 }, out = [];
      each(cells, function (x) { x.textContent = pad(v[x.getAttribute('data-u')]); out.push(x.textContent); });
      if (mini) mini.textContent = out.join(':');
    }
    tick(); if (over) return;
    timer = setInterval(tick, 1000);
    if (st && hero && 'IntersectionObserver' in window) { ob = new IntersectionObserver(function (es) { if (!over) stickyOn(!es[0].isIntersecting); }); ob.observe(hero); }
  }
  /* the Mystery card opens #bfinfo on its own part (capture: before assets/up.js opens and focuses the sheet) */
  D.addEventListener('click', function (e) {
    var o = e.target.closest && e.target.closest('[data-u-win] [data-u-open][data-u-sec]'); if (!o) return;
    var p = D.getElementById(o.getAttribute('data-u-open')), sec = o.getAttribute('data-u-sec'); if (!p) return;
    each(p.querySelectorAll('[data-u-bfsec]'), function (x) { x.hidden = x.getAttribute('data-u-bfsec') !== sec; });
  }, true);
  /* the header bar stays above the shared scrim; while the sheet is up it is tinted (up-skin-pages.css) and a tap on it
     closes the sheet, as the menu does (assets/up-menu.js) */
  D.addEventListener('click', function (e) {
    if (!window.upPanel || window.upPanel.current() !== 'bfinfo' || !D.querySelector('[data-u-win] #bfinfo')) return;
    if (e.target.closest && e.target.closest('store-header.header')) { e.preventDefault(); e.stopPropagation(); window.upPanel.close(); }
  }, true);

  function init(scope) {
    each((scope || D).querySelectorAll('[data-u-about]'), about);
    each((scope || D).querySelectorAll('[data-u-win]'), win);
  }
  init();
  if (D.readyState === 'loading') D.addEventListener('DOMContentLoaded', function () { init(); });
  D.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
